import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ForgotPasswordComponent } from '../../components/account/forgot-password.component';
import { LoginComponent } from '../../components/account/login.component';
import { ResetPasswordComponent } from '../../components/account/reset-password.component';
import { NewUserRequestComponent } from '../../components/user-request/new-user-request.component';
import { UserRequestCreatePasswordComponent } from '../../components/user-request/user-request-create-password.component';
import { AntiAutoCompleteDirective } from '../../directives/anti-auto-complete.directive';
import { EqualValidator } from '../../directives/equal-validator.directive';
import { VmeCommonModule } from '../../vme-common.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { AccountRoutingModule } from './account-routing.module';
import { ToastModule } from 'primeng';
import { RecaptchaFormsModule } from 'ng-recaptcha';
import { NgOptimizedImage } from '@angular/common';

/**
 * Account module, handles /account routes
 * Used for login, password reset, new user requests
 */
@NgModule({
  imports: [
    AccountRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    ToastModule,
    RecaptchaFormsModule,
    NgOptimizedImage,
  ],
  declarations: [
    LoginComponent,
    ResetPasswordComponent,
    ForgotPasswordComponent,
    EqualValidator,
    NewUserRequestComponent,
    UserRequestCreatePasswordComponent,
    AntiAutoCompleteDirective,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AccountModule {}
